import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent
} from '@mui/material';
import Pagination from 'base/ui/components/Pagination/pagination';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { BsFillPlusSquareFill } from 'react-icons/bs';
import { FaCheck } from 'react-icons/fa';
import { HiSearch } from 'react-icons/hi';
import { MdOutlineClose } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { StyleCategory } from 'services/styleCategory_services';
import * as rootStore from 'stores/root_store';
import { PAGE_SIZE_DEFAULT } from 'utils/constants';

export function createStyleCategory() {
  return observer(() => {
    const navigate = useNavigate();
    // =================== phân trang ==========================//
    // số lượng items trên 1 trang
    const [pageSize, setPageSize] = useState(PAGE_SIZE_DEFAULT);
    // current page
    const [pageIndex, setPageIndex] = useState(1);

    // Form validation-----------------------------------
    const { register, handleSubmit, setValue } = useForm<StyleCategory>();

    // ---------------------------STATE VALUE -----------------------------------
    const [styleCategory, setStyleCategory] = useState<StyleCategory>({
    });


    // Set trạng thái để tìm kiếm
    const [status, setStatus] = useState('null');
    const column = [
      {
        columnName: 'STT',
        align: 'text-center',
        visible: true,
      },
      { columnName: 'Mã phân cấp', align: 'text-center', visible: true },
      { columnName: 'Tên phân cấp', align: 'text-center', visible: true },
      { columnName: 'Mã nhóm sản phẩm', align: 'text-center', visible: true },
      { columnName: 'Tên nhóm sản phẩm', align: 'text-center', visible: true },
      { columnName: 'Mã nhóm sản phẩm chi tiết', align: 'text-center', visible: true },
      { columnName: 'Tên nhóm sản phẩm chi tiết', align: 'text-center', visible: true },
      { columnName: 'Mã kiểu dáng sản phẩm', align: 'text-center', visible: true },
      { columnName: 'Tên kiểu dáng sản phẩm', align: 'text-center', visible: true },
    ];

    const tstyleCategoryStore = rootStore.styleCategoryStore.styleCategory;

    // ====================== FUNCTION =============================
    // =========== get keyword stepName ==================


    const handleChange = (event: SelectChangeEvent) => {
      setStatus(event.target.value);
    };
    const handleChangePageIndex = (data: any) => {
      setPageIndex(data.selected + 1);
    };

    const handleChangePageSize = (e: React.ChangeEvent<HTMLSelectElement>) => {
      setPageSize(parseInt(e.target.value));
    };



    // các row trong table lấy từ store
    const tableRows = rootStore.styleCategoryStore.styleCategory.data;

    const onSearch = async (data: StyleCategory) => {
      setStyleCategory({
        productStyleName: data.productStyleName
      });
      // console.log(data);
      await rootStore.styleCategoryPresenter.getListStyleCategory(
        rootStore.styleCategoryStore,
        {
          paging: {
            pageIndex: 1,
            pageSize: pageSize,
          },
          productStyleName: data.productStyleName || null
        }
      );
    };

    // ======================USE EFFECT =====================
    useEffect(() => {
      // lấy danh sách test target theo paging
      const getListTestTarget = async () => {
        await rootStore.styleCategoryPresenter.getListStyleCategory(
          rootStore.styleCategoryStore,
          {
            paging: {
              pageIndex: pageIndex,
              pageSize: pageSize,
            },
          }
        );
      };
      getListTestTarget();
    }, [pageIndex]);


    useEffect(() => {
      const getListTestTarget = async () => {
        await rootStore.styleCategoryPresenter.getListStyleCategory(
          rootStore.styleCategoryStore,
          {
            paging: {
              pageIndex: 1,
              pageSize: pageSize,
            },
          }
        );
      };
      setPageIndex(1);
      getListTestTarget();
    }, [pageSize]);

    return (
      <div className='w-full py-3 px-5'>
        <div className='flex justify-between items-center mb-2'>
          <h3 className='text-md font-bold text-gray-800 uppercase'>
            Kiểu dáng sản phẩm
          </h3>
        </div>
        {/* Form nhập tìm kiếm */}
        <div className='w-full bg-white p-3.5 flex rounded mb-2 border border-neutral-300'>
          <form className='w-full lg:grid lg:grid-cols-2 flex flex-col gap-2'>
            {/*  tên chỉ tiêu */}
            <div className='w-full sm:flex-row sm:items-center grid grid-cols-3'>
              <label className='min-w-[150px] font-medium text-default text-gray-700 sm:text-end'>
                Tên kiểu dáng
              </label>
              <input
                {...register('productStyleName')}
                type='text'
                className='col-span-2 text-gray-700 border border-border_input sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600'
              />
            </div>

            <div className='lg:col-span-2 w-full flex justify-center'>
              <button
                onClick={handleSubmit(onSearch)}
                type='submit'
                className={`flex items-center text-white bg-blue-700 rounded text-default px-2.5 py-1 mt-1 text-center focus:outline-none hover:bg-blue-600 `}
              >
                <>
                  <HiSearch className='font-bold text-lg' />
                  Tìm kiếm
                </>
              </button>
            </div>
          </form>
        </div>

        <div className='w-full bg-white p-3.5 rounded border border-neutral-300'>
          {/*=========== Pagination =======================*/}
          <Pagination
            pageCount={rootStore.styleCategoryStore.styleCategory.pagesCount}
            forcePage={pageIndex - 1}
            onPageSizeChange={handleChangePageSize}
            onPageChange={handleChangePageIndex}
          />

          {/* =========== Table ===============*/}
          <div className={`overflow-x-auto mt-3.5`}>
            <table className='w-full table-auto border-collapse space-collapse text-default'>
              <thead className='font-medium text-gray-700 bg-gray-100'>
                <tr>
                  {column?.map((item, index) => {
                    if (item.visible) {
                      return (
                        <th
                          key={index}
                          scope='col'
                          className={`${item.visible ? '' : 'hidden'
                            } py-1.5 px-5 border whitespace-nowrap text-left ${item.align
                            }`}
                        >
                          {item.columnName}
                        </th>
                      );
                    }
                  })}
                </tr>
              </thead>
              <tbody>
                {tableRows?.map((row, index) => (
                  <tr
                    className={`${1 % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}
                    key={row.stt}
                  >
                    {/* Số thứ tự */}
                    <td className='py-1 border whitespace-nowrap text-center'>
                      {row.stt}
                    </td>
                    {/* phân cấp */}
                    <td className='py-1 border whitespace-nowrap text-center'>
                      {row.productClassCode}
                    </td>
                    <td className='py-1 border whitespace-nowrap text-center'>
                      {row.productClassName}
                    </td>
                    {/* nhóm sản phẩm */}
                    <td className='py-1 border whitespace-nowrap text-center'>
                      {row.productGroupCode}
                    </td>
                    <td className='py-1 border whitespace-nowrap text-center'>
                      {row.productGroupName}
                    </td>
                    {/* nhóm sản phẩm chi tiết */}
                    <td className='py-1 border whitespace-nowrap text-center'>
                      {row.businessProductGroupCode}
                    </td>
                    <td className='py-1 border whitespace-nowrap text-center'>
                      {row.businessProductGroupName}
                    </td>
                    {/* kiểu dáng */}
                    <td className='py-1 border whitespace-nowrap text-center'>
                      {row.productStyleCode}
                    </td>
                    <td className='py-1 border whitespace-nowrap text-center'>
                      {row.productStyleName}
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <span className='block mt-3.5 text-default'>
            Đang xem {`${rootStore.styleCategoryStore.styleCategory.resultsCount}`} trong tổng số{' '}
            {`${rootStore.styleCategoryStore.styleCategory.recordsTotal}`} mục
          </span>
        </div>
      </div>
    );
  });
}
